import { GridColDef } from '@mui/x-data-grid'
import { Item } from '../../../../interfaces/Commons/Items/items';
import { useDates } from '../../../../hooks/useDates';
import { useTranslation } from 'react-i18next';

export const useColumnsItems = () => {
  const { TimeConverter } = useDates();
  const [t] = useTranslation("global");

  const columnsItems: GridColDef<Item>[] = [
    { field: 'item_code', headerName: t("items.fields.item_code"), headerClassName: 'header-grid-table', flex: 1 },
    { field: 'item_description', headerName: t("items.fields.item_description"), headerClassName: 'header-grid-table', flex: 1 },
    { field: 'item_type_name', headerName: t("items.fields.item_type_name"), headerClassName: 'header-grid-table', flex: 1 },
    { field: 'item_family_name', headerName: t("items.fields.item_family_name"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'creation_date', headerName: t("generic.creation_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
      valueGetter(params) {
        return TimeConverter(params.value);
      },
    },
    { field: 'last_update_user', headerName: t("generic.last_update_user"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'last_update_date', headerName: t("generic.last_update_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
      valueGetter(params) {
        return TimeConverter(params.value);
      },
    },
  ];

  return {
    columnsItems,
  }
}
